'use client';

import { MinimalFeaturesQueryResult } from '@app/sanity.types';
import { useAuth } from '@clerk/nextjs';
import { Button } from 'antd';
import { Menu as MenuIcon } from 'lucide-react';
import { FC, useState } from 'react';
import LeftMenu from './LeftMenu';
import { MainDrawer } from './MainDrawer';
import RightMenu from './RightMenu';
import UserDrawerNav from './UserNav/UserDrawerNav';

interface InteractiveHeaderProps {
  featuresItems?: MinimalFeaturesQueryResult;
}

const InteractiveHeader: FC<InteractiveHeaderProps> = ({ featuresItems }) => {
  const { isSignedIn } = useAuth();

  const [mainDrawer, setMainDrawer] = useState<boolean>(false);

  const showDrawer = (): void => {
    setMainDrawer(true);
  };

  const onClose = (): void => {
    setMainDrawer(false);
  };

  return (
    <>
      <Button type="text" onClick={showDrawer} style={{ padding: '0 6px' }} icon={<MenuIcon size={20} />} />

      <MainDrawer goBack={false} onClose={onClose} visible={mainDrawer}>
        <LeftMenu featuresItems={featuresItems} />
        <RightMenu />
        {isSignedIn && <UserDrawerNav />}
      </MainDrawer>
    </>
  );
};

export { InteractiveHeader };
